import React, {Component} from 'react';
import Header from "../Header/Header";

class Dashboard extends Component {
  render() {
    return(
      <div>
        <Header {...this.props}/>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Dashboard.jsx